module.exports = __webpack_public_path__ + "img/mcontact3.369b9de7.png";